import Quill from "quill";

export interface Config {
  container: string
  unit: 'word'|'char'
  maxLength?: number
}

export interface QuillInstance extends Quill {
  container: HTMLDivElement;
}

export class QuillCounterModule {
  quill: QuillInstance
  options: Config

  constructor(quill: QuillInstance, options: Config) {
    this.quill = quill
    this.options = options

    const rootContainer = this.quill.container.parentElement;

    if (!rootContainer) {
      return;
    }

    const moduleContainer = rootContainer.querySelector('.ql-toolbar .ql-module-counter');

    if (!moduleContainer) {
      return;
    }

    this.quill.on('text-change', () => {
      const length = this.calculate()

      moduleContainer.innerHTML = this.options.maxLength ? `${length}/${this.options.maxLength}` : length.toString();

      if (!this.options.maxLength) {
        return;
      }

      if (length > this.options.maxLength) {
        moduleContainer.classList.add('text-danger')
      } else {
        moduleContainer.classList.remove('text-danger')
      }
    });
  }

  calculate(): number {
    const text = this.quill.getText().trim()

    if (this.options.unit === 'word') {
      return !text ? 0 : text.split(/\s+/).length
    }

    return text.length;
  }
}
